import classname from "classnames";
import React, { PureComponent, ReactNode } from "react";

import Error from "./Error.component";

export interface IProps {
  className?: string;
  message?: string | null;
}

type IDefaultProps = Required<Pick<IProps, "className">>;

export default class FormErrorMessage extends PureComponent<
  IProps,
  {},
  IDefaultProps
> {
  public static defaultProps: IDefaultProps = { className: "" };

  public render(): ReactNode {
    const { className, message } = this.props;
    if (!message) {
      return null;
    }

    return (
      <Error className={classname(className, "errorMessage")}>
        {this.props.message}
      </Error>
    );
  }
}
